export default __webpack_public_path__ + "static/media/IMG_8309.64c60cbb.jpeg";